/**
 * @generated SignedSource<<d880cb3bcd3290c9789b168d21c48ee4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryNewPaneTitle_transaction$data = {
  readonly sku: {
    readonly " $fragmentSpreads": FragmentRefs<"ImageMultiSkuOverlay_sku">;
  } | null;
  readonly summary: {
    readonly invoiceSummary: {
      readonly buyerCurrentInvoice: {
        readonly totalAmount: {
          readonly " $fragmentSpreads": FragmentRefs<"CheckoutFormatAmount_financialAmount">;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSummaryItemSkuDetails_transaction">;
  readonly " $fragmentType": "CheckoutMobileSummaryNewPaneTitle_transaction";
};
export type CheckoutMobileSummaryNewPaneTitle_transaction$key = {
  readonly " $data"?: CheckoutMobileSummaryNewPaneTitle_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryNewPaneTitle_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryNewPaneTitle_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TransactionSummaryObject",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceSummary",
          "kind": "LinkedField",
          "name": "invoiceSummary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Invoice",
              "kind": "LinkedField",
              "name": "buyerCurrentInvoice",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "totalAmount",
                  "plural": false,
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "CheckoutFormatAmount_financialAmount"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "sku",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ImageMultiSkuOverlay_sku"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSummaryItemSkuDetails_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "2c4828bc797e577cc3e3b20064f2a1cd";

export default node;
